//taken and modified from https://github.com/JamesEggers1/node-DateValidator/blob/master/src/date-validator.js
export function isDateValid(year: string, month: string, day: string): boolean{
    if (typeof year === 'undefined' || typeof month === 'undefined' || typeof day === 'undefined') {
        return false;
    }

    let yearParsed = Number(year);
    let monthParsed = Number(month);
    let dayParsed = Number(day);

    if (isNaN(monthParsed) || isNaN(dayParsed) || isNaN(yearParsed)) {
        return false;
    }

    monthParsed = parseInt(month, 10);
    dayParsed = parseInt(day, 10);
    yearParsed = parseInt(year, 10);

    if (monthParsed < 1 || dayParsed < 1 || yearParsed < 1) {
        return false;
    }

    // javascript's date object, with all its glory, does not fail or throw if an invalid date is given 
    // such as 2019-02-29 (this day does not exist) but
    // instead parses that as 2019-03-01.
    var tmp_date = new Date(month + '/' + dayParsed + '/' + year);
    if (isNaN(tmp_date.getDate())) {
        return false;
    }

    if (tmp_date.getDate() !== dayParsed) {
        return false;
    }

    if (tmp_date.getMonth() + 1 !== monthParsed) {
        return false;
    }

    return true;
};